module.exports = {"id":"186954","name":"Brown Ideye","rating":"74","photo":"./data/images/photos/2/186954.png","club":{"name":"Málaga CF","logo":"./data/images/clubs/MalagaCF.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/BrownIdeye0.json
// module id = 650
// module chunks = 0